// extracted by mini-css-extract-plugin
var _1 = "_confirmEarmarkApprovalModal-module__button-container";
var _2 = "_confirmEarmarkApprovalModal-module__cancel-button";
var _3 = "_confirmEarmarkApprovalModal-module__confirm-approve";
var _4 = "_confirmEarmarkApprovalModal-module__confirm-reject";
export { _1 as "button-container", _2 as "cancel-button", _3 as "confirm-approve", _4 as "confirm-reject" }
